import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE, copy } from '../data/noklar';
export function FinalCta() {
  const t = copy.finalCta;
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-106" data-mp="19fgudzs6f45c">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-107" data-mp="15dlxr8l6xexw" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-108" data-mp="1jc3gerw8o18y">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-109" data-mp="1eebmxtfy472n">
          {t.titleStart} <em className="text-red-700" data-id="element-110" data-mp="1t37ttn69ne1o">{t.titleAccent}</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-111" data-mp="1o3vahcelsp3u">
          {t.text}
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-112" data-mp="223365vbk5f3a">
          {t.closing}
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-113" data-mp="1x64hhsany0ch">
          {t.recap.map(item => <li key={item} data-id="element-114" data-mp="n7yu2vzo38mu">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-115" data-mp="s5gx65r06tmx">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-116" data-mp="x27e0vamtt9e">{t.oneTime}</p>

        <div className="mt-8 flex justify-center" data-id="element-117" data-mp="12352tqq5dljv">
          <CtaButton className="w-full sm:w-auto" data-id="element-118" data-mp="120ilizdgfrog" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-119" data-mp="163p1iyqdcx84">
          {t.reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-120" data-mp="1b170pxel3y2x">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-121" data-mp="1fvkyu7kmsjba" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}